import * as React from 'react';
import AddBox from 'material-ui/svg-icons/content/add-box';
import FileUpload from 'material-ui/svg-icons/file/file-upload';
import FileDownload from 'material-ui/svg-icons/file/file-download';
import RemoveCircleOutline from 'material-ui/svg-icons/content/remove-circle-outline';
import SwapHoriz from 'material-ui/svg-icons/action/swap-horiz';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const ActionBar = ({
  history,
  state: { sort, order, page, pageSize, filters, checkedItems, universalFilter }
}) => {
  const params = { sort, order, page, pageSize, filters, checkedItems, universalFilter };
  return (
    <>
      <ColumnManager agenda={Agenda.PROTOCOLS} />
      <EnhancedExportButton location={'protocolOverview'} params={params} />
      <div style={{ marginLeft: 5 }}>
        {[
          { label: 'Dodejka', icon: <AddBox />, name: 'procurement' },
          { label: 'Výdejka', icon: <FileUpload style={{ transform: 'rotate(90deg)' }} />, name: 'issue' },
          { label: 'Příjemka', icon: <FileDownload style={{ transform: 'rotate(270deg)' }} />, name: 'receipt' },
          { label: 'Likvidační protokol', icon: <RemoveCircleOutline />, name: 'disposal' },
          { label: 'Převodka', icon: <SwapHoriz />, name: 'transfer' }
        ].map(button => (
          <Button
            label={button.label}
            key={button.name}
            icon={button.icon}
            onClick={() => history.push(`/warehouses/protocols/${button.name}`)}
            style={{ marginLeft: 5 }}
            type="button"
          />
        ))}
      </div>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/modules/protocols/ProtocolsGridButtons.tsx